import { gql } from '__generated__'

export const GetLatestErrorDownload = gql(/* GraphQL */ `
    query GetLatestErrorDownload {
        latestErrorDownload {
            url
            updatedAt
        }
    }
`)

export const GetBulkUploadProcesses = gql(/* GraphQL */ `
    query GetBulkUploadProcesses {
        userProcesses(
            types: ["candidate_bulk_upload"]
            eventTypes: [
                "started"
                "validating"
                "processing"
                "creating_roster"
                "success"
                "error"
            ]
        ) {
            id
            type
            payload
            createdAt
            latestEvent {
                id
                type
                metadata
                createdAt
            }
        }
    }
`)

export const RetryBulkUpload = gql(/* GraphQL */ `
    mutation RetryBulkUpload($processId: ID!) {
        retryUserProcess(processId: $processId) {
            id
        }
    }
`)

export const DismissBulkUploadProcess = gql(/* GraphQL */ `
    mutation DismissBulkUploadProcess($processId: ID!) {
        dismissBulkUploadProcess(processId: $processId)
    }
`)
